import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const COUNTRIES = ["US", "CA", "GB", "DE", "FR", "IN", "AU", "BR", "JP", "SG", "NL"];
const CURRENCIES = ["USD", "EUR", "GBP", "INR", "CAD", "AUD"];

export const ProfileCard = () => {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState({
    business_name: user?.business_name || "",
    country: user?.country || "US",
    default_currency: user?.default_currency || "USD",
    crypto_address: user?.crypto_address || "",
  });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/profile", form);
      await refresh();
      toast.success("Profile saved");
    } catch {
      toast.error("Failed to save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="md:col-span-7 border border-[#262626] p-6" data-testid="profile-section">
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-5">Profile</div>
      <div className="space-y-4">
        <label className="block">
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Business name</div>
          <input
            value={form.business_name}
            onChange={(e) => setForm({ ...form, business_name: e.target.value })}
            data-testid="business-name-input"
            className="w-full bg-[#0A0A0A] border border-[#262626] px-3 py-2.5 text-sm focus:outline-none focus:border-white"
          />
        </label>
        <div className="grid grid-cols-2 gap-3">
          <label className="block">
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Country</div>
            <select
              value={form.country}
              onChange={(e) => setForm({ ...form, country: e.target.value })}
              data-testid="country-select"
              className="w-full bg-[#0A0A0A] border border-[#262626] px-3 py-2.5 text-sm focus:outline-none focus:border-white"
            >
              {COUNTRIES.map((c) => <option key={c}>{c}</option>)}
            </select>
          </label>
          <label className="block">
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Default currency</div>
            <select
              value={form.default_currency}
              onChange={(e) => setForm({ ...form, default_currency: e.target.value })}
              data-testid="currency-select"
              className="w-full bg-[#0A0A0A] border border-[#262626] px-3 py-2.5 text-sm focus:outline-none focus:border-white"
            >
              {CURRENCIES.map((c) => <option key={c}>{c}</option>)}
            </select>
          </label>
        </div>
        <label className="block">
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-2">Crypto wallet address</div>
          <input
            value={form.crypto_address}
            onChange={(e) => setForm({ ...form, crypto_address: e.target.value })}
            placeholder="0x..."
            data-testid="crypto-address-input"
            className="w-full bg-[#0A0A0A] border border-[#262626] px-3 py-2.5 text-sm font-mono focus:outline-none focus:border-white"
          />
        </label>
        <button
          onClick={save}
          disabled={busy}
          data-testid="save-profile-btn"
          className="bg-white text-black text-sm font-medium px-4 py-2.5 rounded-md hover:bg-zinc-200 disabled:opacity-50"
        >
          {busy ? "Saving…" : "Save profile"}
        </button>
      </div>
    </section>
  );
};
